module.exports = __webpack_public_path__ + "img/video-placeholder.baf57f23.png";